"use client";

import {
  isLinkedWordPracticeInstructions,
  resolveEffectiveCustomInstructions,
} from "@/lib/practiceSentenceUrl";

export type InitialCustomInstructionsLifetime = "persistent" | "route-scoped";

interface UseInitialCustomInstructionsOptions {
  initialCustomInstructions?: string | null;
  savedCustomInstructions: string;
  lifetime?: InitialCustomInstructionsLifetime;
}

export function useInitialCustomInstructions({
  initialCustomInstructions,
  savedCustomInstructions,
  lifetime = "persistent",
}: UseInitialCustomInstructionsOptions) {
  const normalizedInitialCustomInstructions = initialCustomInstructions?.trim() || null;
  const shouldClearSavedCustomInstructions =
    isLinkedWordPracticeInstructions(savedCustomInstructions);

  const effectiveCustomInstructions = resolveEffectiveCustomInstructions(
    normalizedInitialCustomInstructions,
    shouldClearSavedCustomInstructions ? "" : savedCustomInstructions
  );

  return {
    effectiveCustomInstructions,
    shouldClearSavedCustomInstructions,
    shouldPersistInitialCustomInstructions: lifetime === "persistent",
  } as const;
}
